<template>
    <Modal
        :title="translate('components.datatable.create_new_template')"
        size="xs"
        ref="Modal"
    >
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">
                    <FormGroup :label="translate('labels.name')">
                        <Input
                            v-model="name"
                            :placeholder="translate('labels.name')"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <Button size="sm"
                :text="translate('buttons.save')"
                @click="upsertTemplate"
                color="teal"
            >
                {{ translate('buttons.save') }}
            </Button>
            <Button size="sm"
                v-if="!!this.uuid"
                @click="deleteTemplate"
                color="danger"
                class="ml-2"
            >
                {{ translate('buttons.delete') }}
            </Button>
        </div>
    </Modal>
</template>
<script>

import Modal from './../../../../components/new/modal/AppModal.vue'
import FormGroup from './../../../../components/new/form/group/FormGroup.vue'
import Input from './../../../../components/new/form/Input.vue'
import Button from './../../../../components/new/button/AppButton.vue'
import { httpClient } from '../../../../services/HttpClient'

export default {
    name: "UpsertTemplateModal",
    components: {
        Modal,
        FormGroup,
        Input,
        Button,
    },
    data() {
        return {
            uuid: '',
            name: '',
            cache: {},
            type: ''
        }
    },
    methods: {
        show(template, templateCache, config) {
            this.uuid = template.uuid;
            this.name = template.name;
            this.type = config.templateType;
            this.cache = templateCache;

            this.$refs.Modal.show();
        },
        async upsertTemplate()
        {
            let params = {
                type: this.type,
                name: this.name,
                main: false,
                personal: true,
                cache: this.cache
            }

            if (this.uuid) {
                await httpClient.put(`/table-templates/${this.uuid}`, params).then(() => {
                    this.$refs.Modal.hide();
                    this.goToTemplate(this.uuid);
                })
                return
            }

            await httpClient.post(`/table-templates`, params).then((response) => {
                this.$refs.Modal.hide();
                this.goToTemplate(response.data.data.uuid);
            })
        },
        async deleteTemplate()
        {
            return await httpClient.delete(`/table-templates/${this.uuid}`).then(() => {
                this.$refs.Modal.hide();
                this.goToTemplate(null);
            })
        },
        goToTemplate(uuid) {
            if ((uuid ?? null) === (this.$route.query.template ?? null)) {
                return;
            }

            let query = {...this.$route.query};

            if (uuid) {
                query.template = uuid;
            } else {
                delete query.template;
            }

            this.$router.push({query});
        }
    }
}
</script>
